var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDiscounts = function SvgDiscounts(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 76,
    viewBox: "0 0 65 76",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.62 5.2L6.332 25.62c-.53.962-.602 2.111-.196 3.132l16.712 42.096c.18.46.538.83.993 1.026.454.196.968.203 1.427.018l17.564-6.972L60.4 57.948c.46-.182.829-.539 1.025-.993.197-.454.205-.967.023-1.427L44.4 12.636c-.206-.518-.633-.917-1.164-1.088L20.208 4.156c-1.002-.32-2.09.118-2.588 1.044z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.764 15.7l-5.388 4.876c-.793.718-1.223 1.752-1.172 2.82l2.084 44c.023.481.236.933.592 1.258.356.324.827.493 1.308.47l12.528-.592"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.684,
    cy: 17.236,
    r: 4.464
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 16.9C21.948 14.168 14.4 1.096 7.64.224 6.732.108 4.44.36 3.584 1.792c-.725 1.32-.795 2.902-.188 4.28 1.972 3.564 6.496 5.876 9.628 7.056M39.68 30.104L28.42 56.192"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.064,
    cy: 39.268,
    r: 3.868
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.56,
    cy: 47.136,
    r: 3.868
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscounts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discounts.579baee3.svg";
export { ForwardRef as ReactComponent };